/**
 * App Settings
 */
const settings = {
  night_mode: localStorage.getItem('night_mode') == 'true' ? true : false,
  spotlight_mode:
    localStorage.getItem('spotlight_mode') == 'true' ? true : false,
  show_section_lines:
    localStorage.getItem('show_section_lines') == 'true' ? true : false,
  sidebar_dark: localStorage.getItem('sidebar_dark') == 'true' ? true : false,
  sidebar_static:
    localStorage.getItem('sidebar_static') == 'true' ? true : false,
  sidebar_small: false,
  sidebar_effect: 'shrink',
  nav: true,
  nav_dark: false,
  nav_logo_path: require('../assets/images/logo_welcome.png'),
  nav_logo_white_path: require('../assets/images/logo_welcome.png'),
  nav_logo_width: '130px',
  login_logo_width: '250px',
  nav_logo_url: '/',
  nav_expand: 'lg',
  nav_sticky: true,
  nav_container_fluid: true,
  nome_ambiente: 'Monitoraggio',
  nome_sportello_web: 'Sportello Web',
  nome_sportello_light: 'Sportello Ambulatoriale Light',
  navigation: {},
  navigation_sidebar: {
    // Strumenti
    '/monitoraggio': {
      label: 'Strumenti',
      name: 'Monitoraggio',
      icon: 'heart-rate-monitor',
    },
    '/grafici': {
      name: 'Grafici',
      icon: 'chart-line',
    },
    '/statistiche': {
      name: 'Statistiche',
      icon: 'file-export',
    },

    //sportelli
    '/web': {
      label: 'Sportelli',
      name: 'Sportelli Live',
      icon: 'building-store',
      sub: {
        '/web': {
          name: 'Web',
        },
        '/ambulatoriale-light': {
          name: 'Ambulatoriale Light',
        },
        '/ambulatoriale-code': {
          name: 'Ambulatoriale Code',
        },
        '/ambulatoriale-code-full': {
          name: 'Ambulatoriale Code Full',
        },
      },
    },

    // Amministratore
    '/ambienti': {
      label: 'Admin',
      name: 'Ambienti',
      icon: 'world',
    },
    '/code': {
      name: 'Code',
      icon: 'list-numbers',
    },
    '/sportelli': {
      name: 'Sportelli',
      icon: 'building-store',
      sub: {
        '/sportelli': {
          name: 'Dispositivi',
          icon: 'list',
        },
        '/policy': {
          name: 'Policy',
          icon: 'puzzle',
        },
        '/prestazioni': {
          name: 'Prestazioni',
          icon: 'stethoscope',
        },
      },
    },
    '/totem': {
      name: 'Totem',
      icon: 'device-tablet',
      sub: {
        '/totem': {
          name: 'Dispositivi',
          icon: 'list',
        },
        '/t-ticket': {
          name: 'Ticket',
          icon: 'ticket',
        },
        '/t-bottoni': {
          name: 'Bottoni',
          icon: 'circle',
        },
        '/t-layout': {
          name: 'Layout',
          icon: 'layout',
        },
      },
    },
    '/monitor': {
      name: 'Monitor',
      icon: 'device-desktop',
      sub: {
        '/monitor': {
          name: 'Dispositivi',
          icon: 'list',
        },
        '/m-layout': {
          name: 'Layout',
          icon: 'layout',
        },
      },
    },
    '/display': {
      name: 'Display',
      icon: 'browser',
    },
    '/scanner': {
      name: 'Scanner',
      icon: 'qrcode',
    },
    '/schedulazioni': {
      name: 'Schedulazioni',
      icon: 'calendar',
    },
    '/playlist': {
      name: 'Playlist',
      icon: 'list',
    },
    '/media': {
      name: 'Media',
      icon: 'photo',
    },
    '/utenti': {
      name: 'Utenti',
      icon: 'users',
    },
    '/privacy': {
      name: 'Privacy',
      icon: 'file-info',
    },
    '/permessi': {
      name: 'Permessi',
      icon: 'key',
    },
    '/impostazioni': {
      name: 'Impostazioni',
      icon: 'settings',
    },
  },
  breadcrumbs_presets: {
    apps: {
      '/calendar': 'Calendar',
      '/project-management': 'Project Management',
      '/file-manager': 'File Manager',
      '/profile': 'Profile',
    },
    content: {
      '/grid': 'Grid',
      '/colors': 'Colors',
      '/typography': 'Typography',
      '/component-table': 'Tables',
    },
  },
  img_country: {},
  img_file: {
    empty: require('../assets/images/icon-empty.svg'),
    zip: require('../assets/images/icon-zip.svg'),
    rar: require('../assets/images/icon-rar.svg'),
    html: require('../assets/images/icon-html.svg'),
    php: require('../assets/images/icon-php.svg'),
    css: require('../assets/images/icon-css.svg'),
    js: require('../assets/images/icon-js.svg'),
    doc: require('../assets/images/icon-doc.svg'),
    txt: require('../assets/images/icon-txt.svg'),
    pdf: require('../assets/images/icon-pdf.svg'),
    xls: require('../assets/images/icon-xls.svg'),
    png: require('../assets/images/icon-png.svg'),
    jpg: require('../assets/images/icon-jpg.svg'),
    clearInputIcon: require('../assets/images/icon-clear-input.svg'),
    closeIcon: require('../assets/images/icon-close.svg'),
    confirmIcon: require('../assets/images/icon-confirm.svg'),
    rightAngleBracketIcon: require('../assets/images/icon-right-angle-bracket.svg'),
  },
};

/* Parse GET variables to change initial settings */
const $_GET = {};
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (a, name, value) => {
  $_GET[name] = value;
});

Object.keys($_GET).forEach(name => {
  const isTrue = $_GET[name] === '1';

  switch (name) {
    case 'setting-night-mode':
      settings.night_mode = isTrue;
      break;
    case 'setting-show-section-lines':
      settings.show_section_lines = isTrue;
      break;
    case 'setting-sidebar-small':
      settings.sidebar_small = isTrue;
      break;
    case 'setting-sidebar-dark':
      settings.sidebar_dark = isTrue;
      break;
    case 'setting-nav-dark':
      settings.nav_dark = isTrue;
      break;
    // no default
  }
});

export default settings;
